jQuery(document).ready(($) => {
  // Admin Bar scripts
  const $AdminScope = {
    init: function () {
      this.controlMySites()
    },

    controlMySites: () => {
      let userAccountAdminBar = $('#wpadminbar #wp-admin-bar-my-account #wp-admin-bar-user-info .username').text()

      if(userAccountAdminBar == "estefaniatejerina" ||
        userAccountAdminBar == "consuelotejero" ||
        userAccountAdminBar == "adrianaalbano" ||
        userAccountAdminBar == "eduardateles" ||
        userAccountAdminBar == "anallerena" ||
        userAccountAdminBar == "katherinecoello" ||
        userAccountAdminBar == "danielosornio" ||
        userAccountAdminBar == "samyralemos"){
        $('#myblogs').remove()
      }
    }
  }

  // Admin Bar scripts
  const $AdminBarScope = {
    init: function () {
      this.controlSitesAdminBar()
    },

    controlSitesAdminBar: () => {
      let userAccountAdminBar = $('#wpadminbar #wp-admin-bar-my-account #wp-admin-bar-user-info .display-name').text()

      if(userAccountAdminBar == "estefaniatejerina") {
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-8").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-11").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-12").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-13").remove()
      }
      else if(userAccountAdminBar == "consuelotejero") {
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-1").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-7").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-11").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-12").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-13").remove()
      }
      else if(userAccountAdminBar == "adrianaalbano") {
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-1").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-7").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-8").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-12").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-13").remove()
      }
      else if(userAccountAdminBar == "eduardateles") {
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-1").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-7").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-8").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-12").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-13").remove()
      }
      else if(userAccountAdminBar == "samyralemos") {
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-1").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-7").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-8").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-12").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-13").remove()
      }
      else if(userAccountAdminBar == "anallerena") {
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-1").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-7").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-8").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-11").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-13").remove()
      }
      else if(userAccountAdminBar == "katherinecoello") {
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-1").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-7").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-8").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-11").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-13").remove()
      }
      else if(userAccountAdminBar == "danielosornio") {
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-1").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-7").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-8").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-11").remove()
        $("#wp-admin-bar-my-sites-list #wp-admin-bar-blog-12").remove()
      }
    }
  }

  // Triggers
  const $body = $('body')

  // Admin Scripts
  if ($body.hasClass('wp-admin')) {
    $AdminScope.init()
  }

  // Admin Bar Scripts
  if ($body.hasClass('admin-bar')) {
    $AdminBarScope.init()
  }
})